module.exports = __webpack_public_path__ + "img/congratulation-top.a8ed04c6.png";